import { Flex, Text, useColorModeValue } from "@chakra-ui/react";
import { ReactNode, useState } from "react";
import HelpIcon from "../HelpIcon";
import MetricsTileMenu, { TileMenuGroup } from "./MetricsTileMenu";

const MetricsTile = ({
  title,
  subtitle,
  help,
  children,
  hide,
  optionGroups
}: {
  title: ReactNode;
  subtitle?: ReactNode;
  help?: string;
  hide?: () => void;
  children: ReactNode;
  optionGroups?: TileMenuGroup[];
}) => {
  const [showMenu, setShowMenu] = useState<boolean>(false);
  const backgroundColor = useColorModeValue("white", "gray.900");
  const backgroundBorderColor = useColorModeValue("gray.200", "gray.900");

  return (
    <Flex
      onMouseEnter={() => {
        setShowMenu(true);
      }}
      onMouseLeave={() => {
        setShowMenu(false);
      }}
      px="1rem"
      py={"1rem"}
      flex={1}
      height={"100%"}
      bg={backgroundColor}
      border="1px solid"
      borderColor={backgroundBorderColor}
      borderRadius="sm"
      direction={"column"}
    >
      <Flex justify="space-between" align="center">
        <Text fontSize="1.5rem" fontWeight="semibold" lineHeight={1.1}>
          {title}
        </Text>

        <HelpIcon label={help} />

        <Flex flex="1" justify="flex-end" align={"center"}>
          <MetricsTileMenu
            visible={showMenu}
            hide={hide}
            optionGroups={optionGroups}
          ></MetricsTileMenu>
        </Flex>
      </Flex>

      {typeof subtitle === "string" || !subtitle ? (
        <Flex
          justify={"space-between"}
          pl={"0.5rem"}
          height={"0.5rem"}
          fontSize="0.5rem"
          fontWeight="semibold"
          color={"gray.500"}
        >
          {subtitle}
        </Flex>
      ) : (
        subtitle
      )}
      <Flex flex="1" direction={"column"}>
        {children}
      </Flex>
    </Flex>
  );
};

export default MetricsTile;
